module.exports = __webpack_public_path__ + "static/media/retirement-object-4-0-1.eaa1bd9b.svg";